export default "__VITE_ASSET__c688fc41__"